import { AnimatePresence, motion } from "framer-motion";
import { Sparkles, X } from "lucide-react";
import { useUpgrade } from "../UpgradeContext";

const fmt = (r) => `${r.used}${r.unit ? " " + r.unit : ""} of ${r.limit}${r.unit ? " " + r.unit : ""}`;

export const UpgradeBanner = () => {
  const { banner, metrics, openModal, dismissBanner } = useUpgrade();
  const top = [...metrics].sort((a, b) => b.pct - a.pct)[0];
  const show = banner && top && top.pct >= 80;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
          data-testid="upgrade-banner"
        >
          <div className="mx-4 sm:mx-6 lg:mx-8 mt-4 rounded-xl border border-blue-400/25 bg-gradient-to-r from-blue-500/[0.12] to-purple-500/[0.12] backdrop-blur px-4 py-3 flex items-center gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg cc-gradient text-white">
              <Sparkles size={16} />
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-white font-500 truncate">
                You've used {top.pct}% of your {top.label.toLowerCase()}
                <span className="text-slate-400 font-400"> · {fmt(top)}</span>
              </p>
              <p className="text-xs text-slate-400 hidden sm:block">Upgrade to Pro for unlimited access — never hit a wall again.</p>
            </div>
            <button
              onClick={() => openModal("banner_cta", top.key, { force: true })}
              data-testid="upgrade-banner-cta"
              className="shrink-0 cc-btn-primary text-white rounded-lg px-3.5 py-1.5 text-xs font-500 whitespace-nowrap"
            >
              View plans
            </button>
            <button
              onClick={dismissBanner}
              data-testid="upgrade-banner-dismiss"
              aria-label="Dismiss"
              className="shrink-0 text-slate-400 hover:text-white p-1"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
